import { NgModule, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagedVirtualScrollerComponent } from './paged-virtual-scroller.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { VirtualScrollerModule } from '@shared/components/ngx-virtual-scroller';
import { RouterModule} from '@angular/router';
import { IntersectionObserverService } from 'app/shared/scroll/intersection-observer.service';
import { ScrollBarService } from 'app/shared/scroll/scrollbar.service';


@NgModule({
    imports: [
        CommonModule,
        NgScrollbarModule,
        VirtualScrollerModule,
        RouterModule,
        PagedVirtualScrollerComponent
    ],
    exports: [PagedVirtualScrollerComponent],
    providers: [{
            provide: 'pvsIOS',
            useFactory: (zone: NgZone, scrollBarService: ScrollBarService) => {
                const viewport = new IntersectionObserverService(zone, scrollBarService);
                viewport.setup(null, '0px 0px 20% 0px');
                return (viewport);
            },
            deps: [NgZone, ScrollBarService]
        }]
})
export class PagedVirtualScrollerModule { }
